module.exports = __webpack_public_path__ + "img/leads.d53dc0df.svg";